import { Button, TableItem } from 'components/atoms';
import { Table } from 'components/organisms';
import TopBar from 'components/organisms/top-bar/TopBar';
import { TopbarPage } from 'components/templates';
import { useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { useNewWindowNavigate } from 'hooks/useNewWindowNavigate';
import { useParamId } from 'hooks/useParamId';

import { useTranslation } from 'react-i18next';
import { PiCaretLeftBold, PiNavigationArrow } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { useGetChannelContractHistory } from 'services/channel/settlementInfo';
import { IChannelMutationForm } from 'services/channel/types/query';
import { formatDate } from 'utils/global/date.utils';

const ChannelContractsHistory = () => {
  const channelId = useParamId('channel');

  const { t } = useTranslation();

  const navigate = useNavigate();

  const navigateToNewWindow = useNewWindowNavigate();

  const { status }: IFormikContextType<IChannelMutationForm> =
    useFormikContext<IChannelMutationForm>();

  const history = useGetChannelContractHistory(channelId);

  return (
    <TopbarPage
      topbar={
        <TopBar
          size="compact"
          customBackItem={
            <Button
              isClear
              onlyIcon
              onClick={() =>
                navigate(
                  status?.displayMode
                    ? `/channel/${channelId}/contracts`
                    : `/channel/edit/${channelId}/contracts`,
                )
              }
            >
              <Button.Icon icon={<PiCaretLeftBold />} />
            </Button>
          }
          title={
            history.data?.settlementInfo
              ? `${t('input.label.per-video-settlement')}: ${
                  history.data.settlementInfo.perVideoSettlement
                    ? t('input.option.yes')
                    : t('input.option.no')
                }`
              : undefined
          }
        />
      }
    >
      <Table
        id={'ChannelContractsHistory'}
        size="compact"
        loading={history.isLoading}
        data={{
          nodes:
            history.data?.settlementInfo?.contracts.map((c) => ({
              ...c,
              id: c.contractId,
            })) ?? [],
        }}
        columns={[
          {
            label: `${t('input.label.global')}`,
            renderCell: ({ labelName: name }) => (
              <TableItem>
                <TableItem.Text text={name} />
              </TableItem>
            ),
            resize: true,
          },
          {
            label: t(`input.label.contract`),
            renderCell: (contract) => (
              <TableItem>
                <TableItem.Text text={contract.contractName} />
              </TableItem>
            ),
            resize: true,
          },
          {
            label: t(`input.label.date`),
            renderCell: (contract) => (
              <TableItem>
                <TableItem.Text text={`${formatDate(contract.startDate)}`} />
              </TableItem>
            ),
            resize: true,
          },

          {
            label: t(`input.label.division`),
            renderCell: ({ divisionPercentage, id: index }) => (
              <TableItem>
                <TableItem.Text text={`${divisionPercentage ?? '-'}%`} />
              </TableItem>
            ),
          },
          {
            label: '',
            renderCell: ({ id: index, labelId, contractId }) => (
              <TableItem justifyPosition="end">
                <Button
                  isClear
                  onlyIcon
                  className="flip-icon-x"
                  onClick={() =>
                    navigateToNewWindow(`label/${labelId}/contract/${contractId}/form`)
                  }
                >
                  <Button.Icon icon={<PiNavigationArrow />} />
                </Button>
              </TableItem>
            ),
          },
        ]}
      />
    </TopbarPage>
  );
};

export default ChannelContractsHistory;
